import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'src/app/_models/user.model';
import { Contact } from 'src/app/_models/contact.model';
import { LanguageManagerService } from 'src/app/_services/languagemanager.service';
import { StorageService } from 'src/app/_services/storage.service';
import { BaseComponent } from 'src/app/common/base/base.component';
import { AuthService } from 'src/app/_services/auth.service';
import { ContactGroupService } from 'src/app/_services/contact-group.service';
import { ContactGroup } from 'src/app/_models/contact-group.model';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  standalone: false,
})
export class ProfileComponent extends BaseComponent implements OnInit {

  private userSuscription$!: Subscription;

  username!: string | null;
  tokenData: any;
  contactGroups: ContactGroup[] = [];
  commerces: Contact[] = [];
  page = 1;
  pageSize = 5;
  totalRows = 0;
  totalPages = 0;
  totalContacts = 0;

  pagedCommerces: Contact[] = [];

  constructor(
    private storageService: StorageService,
    public override router: Router,
    public override langService: LanguageManagerService,
    private route: ActivatedRoute,
    private contactGroupService: ContactGroupService,
    private authService: AuthService,
  ) {
    super(router, langService, route);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.username = this.storageService.getUsername();

    this.userSuscription$ = this.storageService.userInfo.subscribe((user) => {
      this.updateUserData(user);
    });

    this.getContactGroup();
    this.getContactsByContactGroupId();
  }

  updateUserData(user: User) {
    this.username = user ? user.user : null;
  }

  getContactGroup() {
    this.tokenData = this.authService.getTokenData();

    this.contactGroupService
      .getContactGroupByContactGroupId(this.tokenData.contactGroupId)
      .subscribe(
        (res: ContactGroup | ContactGroup[]) => {
          this.contactGroups = Array.isArray(res) ? res : [res];

          this.totalContacts = this.contactGroups.length;
          this.contactGroups.forEach(element => {
            element.language = Number(element.data?.TAG_Idioma)
          });

          //console.log(this.contactGroups);
        },
        (error) => {
          console.error('Error al encontrar los grupos de contactos', error);
        }
      );
  }

  getContactsByContactGroupId() {
    this.contactGroupService
      .getContactsByContactGroupId(this.tokenData.contactGroupId)
      .subscribe(
        (res: Contact[]) => {
          this.commerces = res;
          this.totalRows = res.length; // o res[0]?.totalRows si viene así
          this.applyPagination();
        },
        (error) => {
          console.error('Error al encontrar los contactos', error);
        }
      );
  }
  applyPagination() {
    const start = (this.page - 1) * this.pageSize;
    const end = start + this.pageSize;

    this.pagedCommerces = this.commerces.slice(start, end);
    this.totalPages = Math.ceil(this.totalRows / this.pageSize);
  }

  nextPage() {
    if (this.page * this.pageSize < this.totalRows) {
      this.page++;
      this.applyPagination();
    }
  }

  prevPage() {
    if (this.page > 1) {
      this.page--;
      this.applyPagination();
    }
  }
}
